import React from 'react';
import { Info, List, Grid } from 'lucide-react';
import AssistantPagination from './AssistantPagination';
import VirtualAssistantListView from './VirtualAssistantListView';
import VirtualAssistantGridView from './VirtualAssistantGridView';

const VirtualAssistantsContent = ({
  assistants,
  loading,
  viewMode,
  setViewMode,
  searchTerm,
  setSearchTerm,
  currentPage,
  totalPages,
  pageSize,
  setPageSize,
  published_count,
  publishLimit,
  showNote,
  handleToggleNote,
  fetchAssistantsData,
  handleAssistantClick,
  showOptions,
  setShowOptions,
  optionsRef,
  handleCoOwner,
  handleCopyAppUrl,
  handleClone,
  handleExport,
  handleMergeClick,
  handleDelete,
  defaultAIFace
}: any) => {
  return (
    <>
      {/* Header with Published Count */}
      <div className="flex items-center justify-end p-3 pr-1 pl-0">
        <div className="flex items-center gap-2">
          <span className="text-medium text-gray-900">PUBLISHED:</span>
          <div className="relative inline-block">
            <div className="h-6 w-6 bg-black text-white text-xs font-bold flex items-center justify-center rounded-full">
              {published_count}
            </div>
          </div>
         {published_count >= publishLimit && (
            <div className="relative inline-block">
              <div
                className="h-6 w-6 text-black text-xs font-bold flex items-center justify-center rounded-full cursor-pointer"
                onClick={handleToggleNote}
              >
                <Info className="h-5 w-5 text-gray-500" />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Search Bar and View Toggle */}
      <div className="px-3 mb-4 flex items-center justify-between">
        <input
          type="text"
          value={searchTerm}
          onChange={(e: any) => setSearchTerm(e.target.value)}
          placeholder="Search by name"
          className="px-2 py-2 border border-gray-300 rounded-md w-96"
        />
        <div className="flex gap-2">
          <button
            onClick={() => setViewMode("list")}
            className={`p-2 rounded-md ${viewMode === "list" ? "bg-gray-300" : "bg-gray-100"}`}
          >
            <List size={18} />
          </button>
          <button
            onClick={() => setViewMode("grid")}
            className={`p-2 rounded-md ${viewMode === "grid" ? "bg-gray-300" : "bg-gray-100"}`}
          >
            <Grid size={18} />
          </button>
        </div>
      </div>

      {/* Content Area */}
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="loader"></div>
        </div>
      ) : (
        <>
          {viewMode === "list" ? (
            <VirtualAssistantListView
              assistants={assistants}
              handleAssistantClick={handleAssistantClick}
              showOptions={showOptions}
              setShowOptions={setShowOptions}
              optionsRef={optionsRef}
              handleCoOwner={handleCoOwner}
              handleCopyAppUrl={handleCopyAppUrl}
              handleClone={handleClone}
              handleExport={handleExport}
              handleMergeClick={handleMergeClick}
              handleDelete={handleDelete}
              defaultAIFace={defaultAIFace}
            />
          ) : (
            <VirtualAssistantGridView
              assistants={assistants}
              showNote={showNote}
              handleAssistantClick={handleAssistantClick}
              showOptions={showOptions}
              setShowOptions={setShowOptions}
              optionsRef={optionsRef}
              handleCoOwner={handleCoOwner}
              handleCopyAppUrl={handleCopyAppUrl}
              handleClone={handleClone}
              handleExport={handleExport}
              handleMergeClick={handleMergeClick}
              handleDelete={handleDelete}
              defaultAIFace={defaultAIFace}
            />
          )}
          
          {/* Pagination */}
          {!loading && assistants.length > 0 && 
            <AssistantPagination
                currentPage={currentPage}
                totalPages={totalPages}
                pageSize={pageSize}
                searchTerm={searchTerm}
                onPageChange={(page: any) => fetchAssistantsData(page, pageSize, searchTerm)}
                onPageSizeChange={(size: any) => {
                  setPageSize(size);
                  fetchAssistantsData(1, size, searchTerm);
                }}
            />
          }
        </>
      )}
    </>
  );
};

export default VirtualAssistantsContent;